import { useRef, useState } from "react";
import { useFloating, useHover, useFocus, useDismiss, useRole, useInteractions, type ElementProps, arrow } from "@floating-ui/react";
import type { TooltipInteraction, TooltipProps } from "./Tooltip.d";
export const useTooltip = ({
  excludeInteractions,
  ...props
}: Omit<TooltipProps, "children" | "text">) => {
  const [open, setOpen] = useState(false);
  const arrowRef = useRef(null);
  const arrowMiddleware = arrow({
    element: arrowRef
  });
  const {
    x,
    y,
    strategy,
    refs,
    context
  } = useFloating({
    ...props,
    middleware: props.middleware ? [...props.middleware, arrowMiddleware] : [arrowMiddleware],
    open,
    onOpenChange: setOpen
  });
  const interactions: Record<TooltipInteraction, ElementProps> = {
    hover: useHover(context, {
      move: false
    }),
    focus: useFocus(context),
    dismiss: useDismiss(context),
    role: useRole(context, {
      role: "tooltip"
    })
  };
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions(Object.entries(interactions).filter(([k]) => !excludeInteractions?.includes(k as TooltipInteraction)).map(([, v]) => v));
  return {
    open,
    x,
    y,
    strategy,
    refs,
    getReferenceProps,
    getFloatingProps,
    context,
    arrowRef
  };
};